export const ROLES = {
    agent: "agent",
    dev: "dev",
    admin: "admin"
  };
  
  export const SCOPES = {
    canCreate: "can-create",
    canEdit: "can-edit",
    canDelete: "can-delete",
    canUse: "can-use",
    canView: "can-view",
    canDownload: "can-download",
  };
  
  export const PERMISSIONS = {
    [ROLES.agent]: {
        admin:[
            SCOPES.canView,
          ],
        studio:[
            SCOPES.canView,
            SCOPES.canEdit,
            SCOPES.canCreate,
            SCOPES.canDelete
            
        ]
    },
    [ROLES.dev]: {
        admin:[
            SCOPES.canView,
            SCOPES.canUse,
          ],
        studio:[
            SCOPES.canView,
            SCOPES.canEdit,
            SCOPES.canCreate,
            SCOPES.canDelete,
            SCOPES.canUse,
        ]
    },
    [ROLES.admin]: {
        admin:[
            SCOPES.canDownload,
            SCOPES.canView,
            SCOPES.canEdit,
            SCOPES.canCreate,
            SCOPES.canDelete,
            SCOPES.canUse,
          ],
        studio:[
            SCOPES.canDownload,
            SCOPES.canView,
            SCOPES.canEdit,
            SCOPES.canCreate,
            SCOPES.canDelete,
            SCOPES.canUse,
        ]
    }
  };